import { Form, FormProps, message } from "antd";
import api from "common/api";
import { IBranch } from "common/types/common";
import { FieldData } from "rc-field-form/es/interface";
import React, { FC, createContext, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Context = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const onFinish: FormProps["onFinish"] = async (values) => {
    try {
      const payload = {
        ...values,
      };
      const response = await api.branch.addEmployee(payload, id);
      message.success("Filial yaratildi");
      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };

  const getById = async (id: string) => {
    try {
      const response = await api.branch.getById(id);
      const fields: FieldData[] = (
        Object.keys(response.data) as (keyof IBranch)[]
      ).map((key) => ({
        name: key,
        value: response.data[key],
      }));
      form.setFields(fields);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    if (id)
      try {
        const response = await api.branch.delete(id);
        message.success("Filial o'chirildi");
        navigate(-1);
      } catch (err) {
        console.log(err);
      }
    else navigate(-1);
  };

  useEffect(() => {
    if (id) getById(id);
  }, []);

  return {
    state: { form },
    actions: { onFinish, handleDelete },
  };
};

const BranchesAddContext = createContext<any>({ state: {}, actions: {} });

export const BranchesAddContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <BranchesAddContext.Provider value={value}>
      {children}
    </BranchesAddContext.Provider>
  );
};

export default function useBranchesAddContext() {
  return useContext<ReturnType<typeof Context>>(BranchesAddContext);
}
